import { useEffect, useState } from "react";
import { SEO } from "./SEO.tsx";
import "./signup-layout.scss";
import { getHostName } from "../../../api-services/axiosClient";
import { getPathParam } from "../../../utils/get-params-value";

const isDevelopmentEnv =
  process.env.ACTIVE_ENV === "development" || process.env.NODE_ENV === "development";

const SignupLayout = ({ children }) => {
  const planCode = getPathParam(1);
  const [showSEO, setShowSEO] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !planCode) {
      return;
    }

    const shouldUsePaduaDomain = planCode.toLowerCase().includes("padua");
    const hostName = getHostName();

    if (!hostName) {
      return;
    }

    const targetHostName = shouldUsePaduaDomain
      ? `padua.backoffice.${hostName}`
      : `backoffice.${hostName}`;
    const targetHost = isDevelopmentEnv ? `${targetHostName}:8000` : targetHostName;

    if (window.location.host !== targetHost) {
      const { protocol, pathname, search, hash } = window.location;
      window.location.href = `${protocol}//${targetHost}${pathname}${search}${hash}`;
    } else {
      // Load the GTM for the specific domain backoffice.wealthx.au or backoffice.staging.wealthx.au
      if (targetHostName.startsWith("backoffice")) {
        setShowSEO(true);
      }
    }
  }, [planCode]);

  return (
    <>
      {showSEO && <SEO />}
      {children}
    </>
  );
};

SignupLayout.propTypes = {};

export default SignupLayout;
